import { BookedEventNotification } from './bookings-notification-class'
import { defaultNotificationDataInjector } from './subTypesHandler/bookings-notification-default-handler'
import { oneOneOneNotificationDataInjector } from './subTypesHandler/one-on-one-notification-data-injector'

const TYPES_OF_BOOKED_EVENT_NOTIFICATIONS = {
  oneOnOne: '1on1',
}

const BOOKED_EVENT_NOTIFICATION_DATA_INJECTORS = {
  [TYPES_OF_BOOKED_EVENT_NOTIFICATIONS.oneOnOne]: oneOneOneNotificationDataInjector,
}

export function buildBookedEventNotificationData(notificationData, variablesForUse = {}) {
  const bookedEventNotificationData = new BookedEventNotification({
    notificationData,
    variablesForUse,
  })
  const dataInjector =
    BOOKED_EVENT_NOTIFICATION_DATA_INJECTORS?.[bookedEventNotificationData.subType] ||
    defaultNotificationDataInjector

  dataInjector(bookedEventNotificationData)

  return bookedEventNotificationData
}
